import { isEmpty } from '@ember/utils';
import Service, { service } from '@ember/service';
import dateUtils from 'donor-elf-web/lib/date-utils';
import moment from 'moment';

export default class FormatDateService extends Service {
  @service declare settings: any;

  // options
  // - fourYear
  //   - display 4 digit year instead of 2 digit (default is false)
  // - noYear
  //   - excludes the year
  format(
    date: Date | string,
    options: { fourYear?: boolean; noYear?: boolean } = {},
  ) {
    if (isEmpty(date)) {
      return null;
    }
    if (typeof date === 'string') {
      date = dateUtils.deserializeDateOnly(date);
    }
    let format = 'dateFormat';
    if (options.fourYear) {
      format = `${format}4Year`;
    } else if (options.noYear) {
      format = `${format}NoYear`;
    }
    format = this.settings[format] || 'MM/DD/YY';
    return moment(date).format(format);
  }

  formatForFile(date: Date | string | undefined) {
    if (isEmpty(date)) {
      return null;
    }
    return moment(date).format('YYYY-MM-DD');
  }
}
